import React from 'react';
import { useSelector } from 'react-redux';
import * as call from '../../../../call';
import { SELF_PARTICIPANT_ID } from '../../../constants';
import { FormattedMessage } from 'react-intl';
const ParticipantTitle = () => {
    const currentParticipant = useSelector(call.selectors.getCurrentParticipant);
    if (!currentParticipant) {
        return null;
    }
    const isSelfParticipant = SELF_PARTICIPANT_ID === currentParticipant.id;
    const participantScreenName = call.helpers.getParticipantScreenName(currentParticipant.name, currentParticipant.streamType);
    return isSelfParticipant ? (<FormattedMessage id="video-chat.mobile.self-participant"/>) : (<>{participantScreenName}</>);
};
export default ParticipantTitle;
